import { render, staticRenderFns } from "./driverDetailForm.vue?vue&type=template&id=73be7928&scoped=true&"
import script from "./driverDetailForm.vue?vue&type=script&lang=js&"
export * from "./driverDetailForm.vue?vue&type=script&lang=js&"
import style0 from "./driverDetailForm.vue?vue&type=style&index=0&id=73be7928&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73be7928",
  null
  
)

export default component.exports